const routesInsights = [
  {
    path: '/insights/:propertyId/solar-optimisations',
    name: 'InsightsSolarOptimisation',
    component: () => import('@/views/insights/InsightsSolarOptimisations.vue'),
    meta: {
      title: 'Solar Optimisation'
    }
  }
]

export default routesInsights
